import { render } from "./SignInUpPage.vue?vue&type=template&id=5b160d6b&scoped=true"
import script from "./SignInUpPage.vue?vue&type=script&lang=js"
export * from "./SignInUpPage.vue?vue&type=script&lang=js"

import "./SignInUpPage.vue?vue&type=style&index=0&id=5b160d6b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b160d6b"]])

export default __exports__